@if (!displayAsItems()) {
  <bz-table uniqueId="threepl-services"
            appBringozIdGenerator="threepl-services-table"
            [items]="tableItems()"
            [isLoading]="loading()"
            [rowHeight]="75"
            [defaultWidths]="defaultWidths()"
            [settings]="tableSettings()"
            (settingsChange)="onLayoutChange($event)"
            (fetchNext)="fetchNext.emit()">
    <ng-template bzTableHeader>
      <div class="th col-name large text-ellipsis">{{ 'Service' | translate }}</div>
      @if (columns()?.orderId) {
        <div class="th col-order-id small text-ellipsis">{{ 'Order ID' | translate }}</div>
      }
      @if (columns()?.operationalUnits) {
        <div class="th col-branches small text-ellipsis">{{ 'Branches' | translate }}</div>
      }
      @if (columns()?.account) {
        <div class="th col-account large text-ellipsis">{{ 'Account' | translate }}</div>
      }
      @if (columns()?.supplierAccount) {
        <div class="th col-carrier large text-ellipsis">{{ 'Carrier' | translate }}</div>
      }
      @if (columns()?.location) {
        <div class="th col-location large text-ellipsis">{{ 'Location' | translate }}</div>
      }
      @if (columns()?.taskApprovalStatus) {
        <div class="th col-approval-status small text-ellipsis">{{ 'Approval Status' | translate }}</div>
      }
      @if (columns()?.contact) {
        <div class="th col-contact small text-ellipsis">{{ 'Contact' | translate }}</div>
      }
      @if (columns()?.programType) {
        <div class="th col-program-type small text-ellipsis">{{ 'Program Type' | translate }}</div>
      }
      @if (columns()?.eta) {
        <div class="th col-eta small text-ellipsis">
          <span>{{ 'ETA' | translate }}</span>
          <bz-button variant="tertiary" size="fit" appBringozIdGenerator="threepl-services-table-sort-eta-button"
                     [ariaLabel]="'ETA' | translate" (clicked)="sortTypeChange.emit('sortEta')">
            <bz-icon [icon]="sortIcons().sortEta"></bz-icon>
          </bz-button>
        </div>
      }
      @if (columns()?.timeToDeliver) {
        <div class="th col-time-to-deliver small text-ellipsis">{{ 'Time To Deliver' | translate }}</div>
      }
      @if (columns()?.distance) {
        <div class="th col-distance small text-ellipsis">{{ 'Distance' | translate }}</div>
      }
      @if (columns()?.serviceAreas) {
        <div class="th col-service-areas small text-ellipsis">{{ 'Service Areas' | translate }}</div>
      }
      @if (columns()?.timeWindow) {
        <div class="th col-time-window large text-ellipsis">{{ 'Time Window' | translate }}</div>
      }
      @if (columns()?.price) {
        <div class="th col-price small text-ellipsis">{{ 'Price' | translate }}</div>
      }
      @if (columns()?.notes) {
        <div class="th col-notes large">{{ 'DELIVERIES_TABLE_COLUMNS.notes' | translate }}</div>
      }
      @if (columns()?.created) {
        <div class="th col-created small text-ellipsis">
          <span>{{ 'Since Created' | translate }}</span>
          <bz-button variant="tertiary" size="fit" appBringozIdGenerator="threepl-services-table-sort-created-button"
                     [ariaLabel]="'Since Created' | translate" (clicked)="sortTypeChange.emit('sortCreatedAt')">
            <bz-icon [icon]="sortIcons().sortCreatedAt"></bz-icon>
          </bz-button>
        </div>
      }
      @for (column of enabledDynamicColumns(); track column.key) {
        <div class="th small text-ellipsis" [class]="column.cls">{{ column.title }}</div>
      }
    </ng-template>

    <ng-template bzTableRow let-service>
      @if (service.skeleton) {
        <app-threepl-services-table-skeleton-row [columns]="columns()" [dynamicColumns]="enabledDynamicColumns()">
        </app-threepl-services-table-skeleton-row>
      } @else {
      <app-threepl-services-table-row appBringozIdGenerator="externalServiceTableRow"
                                      [service]="service"
                                      [selectedIds]="selectedIds()"
                                      [columns]="columns()"
                                      [dynamicColumns]="enabledDynamicColumns()"
                                      (toggle)="toggleService.emit($event)"
                                      (addNote)="addNote.emit($event)"
                                      (moveToInternal)="moveToInternal.emit($event)"
                                      (cancel)="cancel.emit($event)">
      </app-threepl-services-table-row>
      }
    </ng-template>

    <bz-empty-state bzTableEmptyState
                    [title]="'No services found' | translate"
                    image="assets/images/empty_state/empty_state_location_box.svg">
    </bz-empty-state>
  </bz-table>
} @else {
  <div class="flex layout-column threepl-services-items" appBringozIdGenerator="threepl-services-items-list">
    @for (card of skeletonCards(); track card.id) {
      <bz-skeleton class="threepl-services-item-skeleton" shape="rect" height="120px"></bz-skeleton>
    }
    @if (empty()) {
      <bz-empty-state class="flex"
                      [title]="'No services found' | translate"
                      image="assets/images/empty_state/empty_state_dispatching.png">
      </bz-empty-state>
    } @else {
      <!-- ui-fallback: no bz virtual list; CDK virtual scroll of cards, paged like md-on-demand. -->
      <cdk-virtual-scroll-viewport class="flex" [itemSize]="140" (scrolledIndexChange)="onMobileScrolled()">
        <app-threepl-services-table-item *cdkVirtualFor="let service of items(); trackBy: trackById"
                                         [service]="service"
                                         [columns]="columns()">
        </app-threepl-services-table-item>
      </cdk-virtual-scroll-viewport>
    }
    @if (loading()) {
      <bz-spinner size="sm" class="threepl-services-items-loading"></bz-spinner>
    }
  </div>
}
